// Modules
import styled, { css } from 'styled-components'
import { theme } from '@dasa-health/components-react'

// Application
import { StatusBarProps } from 'typings/components'

export const StyledStatusBar = styled.div<StatusBarProps>`
    font-size: .875rem;
    line-height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;

    & > p {
        margin-left: .75rem;
    }

    ${props =>
        props.status === 'loading' &&
        css`
            &,
            &:focus {
                outline: none;
                color: ${theme.colors.brand.primary[50]};
            }
        `}
    ${props =>
        props.status === 'success' &&
        css`
            &,
            &:focus {
                color: #22723a;
            }
        `}
    ${props =>
        props.status === 'error' &&
        css`
            &,
            &:focus {
                color: #c02a3c;
            }
        `}
`
